export default __webpack_public_path__ + "static/pc_peace-da7c7ebeefe4ebbbcab8053bf7f76d0d.png";